import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';


// Import all tab components
import DocumentsTab from '../Documents/DocumentsTab';
import HearingsTab from '../Hearings/HearingsTab';
import TimesheetTab from '../Timesheet/TimesheetTab';
import GiveTask from '../tasks/GiveTask';
import TaskList from '../tasks/TaskList';

const tabs = [
  'Hearing',
  'Tasks',
  'Documents',
  'Billing Details'
];

function ProjectDetails() {
  const { id: caseId } = useParams();
  const [caseData, setCaseData] = useState(null);
  const [activeTab, setActiveTab] = useState('Hearing');
  const [userRole, setUserRole] = useState(null);


  useEffect(() => {
    const fetchCase = async () => {
      const token = localStorage.getItem("token");

      try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/Projects/${caseId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });
        setCaseData(res.data);
      } catch (err) {
        console.error('Failed to fetch case details:', err);
      }
    };

    fetchCase();
  }, [caseId]);

  useEffect(() => {
    // For example, stored as: { "role": "lawyer", "email": "example@mail.com", ... }
    const userData = JSON.parse(localStorage.getItem("user"));

    if (userData && userData.role) {
      setUserRole(userData.role);
    }
  }, []);

  if (!caseData) {
    return <div className="p-6 text-red-600">Something went wrong. Couldn't load the Project details.</div>;
  }

  return (
    <div className="p-6">
      <div className="mb-6 flex flex-col md:flex-row gap-6 p-4 bg-gradient-to-r from-indigo-100 to-purple-100 rounded-xl shadow-md">
        <div className="flex-1 space-y-4">
          <div className="p-4 bg-white rounded-lg shadow hover:shadow-md transition duration-300">
            <h1 className="text-xl font-bold text-indigo-700">Project Title: <span className="text-gray-900">{caseData.caseTitle}</span></h1>
            <p className="text-sm text-gray-600 mt-1">Project Type: <span className="text-gray-800">{caseData.caseType}</span></p>
          </div>
        </div>

        <div className="flex-1 space-y-4">
          <div className="p-4 bg-white rounded-lg shadow hover:shadow-md transition duration-300">
            <h1 className="text-xl font-bold text-green-700">Project Year: <span className="text-gray-900">{caseData.caseYear}</span></h1>
            <div>Client Name: {caseData.client && caseData.client.clientName}</div>
          </div>
        </div>
      </div>

      <div className="flex space-x-4 border-b border-gray-300 mb-4">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-2 font-medium ${activeTab === tab ? 'border-b-2 border-blue-600 text-blue-600' : 'text-gray-600'
              }`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="mt-4">

        {activeTab === 'Documents' && <DocumentsTab caseId={caseId} />}
        {activeTab === 'Hearing' && <HearingsTab caseId={caseId} />}
        {activeTab === 'Billing Details' && <TimesheetTab caseId={caseId} />}
        {activeTab === 'Tasks' && (
          userRole?.toLowerCase() === 'executive' ? (
            <GiveTask caseId={caseId} />
          ) : (
            <TaskList caseId={caseId} />
          )
        )}

      </div>
    </div>
  );
}

export default ProjectDetails;
